"use client";
import { resolveStyles } from "./resolve-styles/resolve-styles.mjs";
import { resolveStyle } from "./resolve-style/resolve-style.mjs";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-style/get-style.ts
function getStyle({ theme, selector, options, props, stylesCtx, rootSelector, withStylesTransform, resolvedStyles, resolvedThemeStyles, resolvedVars, resolvedRootStyle }) {
	return {
		...resolvedThemeStyles[selector],
		...resolvedStyles[selector],
		...!withStylesTransform && resolveStyles({
			theme,
			styles: options?.styles,
			props: options?.props || props,
			stylesCtx
		})[selector],
		...resolvedVars[selector],
		...rootSelector === selector ? resolvedRootStyle : null,
		...resolveStyle({
			style: options?.style,
			theme
		})
	};
}
//#endregion
export { getStyle };

//# sourceMappingURL=get-style.mjs.map